import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useUserSettings } from '@utils/queries/user.queries';
import { Loader } from '@nazka/nazka.mapframe.components';
import FloodsCustomRadiogroup from './FloodsCustomRadiogroup/FloodsCustomRadiogroup'
import { useUploadedFloodsRecords } from '../../../../utils/queries/upload.queries';
import FloodsLayer from '../../FloodsLayer/FloodsLayer';
import { setCurrentFlood } from '../layer-selector.redux.action';

import './floods-radio.styl'

function FloodsRadios({ map }) {
  const dispatch = useDispatch()
  const { data: floodRecords, isLoading } = useUploadedFloodsRecords()

  const radios = [
    { label: 'Ljubljana floods', value: 'default' },
    ...(floodRecords?.map?.(flood => ({
      label: flood.name,
      value: flood.id,
    })) ?? []),
  ];

  const currentSelectedFlood = useSelector(state => state.layerSelector.currentSelectedFlood)

  const { data: userSettings } = useUserSettings();

  const {
    floodMeasures,
    floodYear,
  } = userSettings || {};

  const scenario = `${floodYear}${floodMeasures || ''}`;

  if (isLoading) return <Loader />

  return (
    <div className="floods-radios">
      <FloodsCustomRadiogroup
        radios={radios}
        name="floods custom"
        onChange={e => dispatch(setCurrentFlood(e))}
        selectedValue={currentSelectedFlood ? radios.find(radio => radio.value === currentSelectedFlood)?.value : 'default'}
      /> 
      {map && <FloodsLayer map={map} scenario={scenario} selectedValue={currentSelectedFlood} />}
    </div>
  )
}

export default FloodsRadios